import {
    FaBoxOpen,
    FaFileInvoiceDollar,
    FaTools,
    FaDesktop,
    FaSearch,
    FaChartBar,
} from "react-icons/fa";

export const tools = [
    {
        id: "purchase-order",
        name: "Purchase Order",
        path: "/tools/purchase-order",
        permission: "tools.purchase_order.execute",
        description: "Generate purchase orders",
        icon: FaBoxOpen,
    },
    {
        id: "purchase-order-all-sheets",
        name: "PO All Sheets",
        path: "/tools/purchase-order-all-sheets",
        permission: "tools.purchase_order_all.execute",
        description: "Generate POs for all sheets",
        icon: FaFileInvoiceDollar,
    },
    {
        id: "sku-builder",
        name: "SKU Builder",
        path: "/tools/sku-builder",
        permission: "tools.sku_builder.execute",
        description: "Create and manage SKUs",
        icon: FaTools,
    },
    {
        id: "display-sheet",
        name: "Display Sheet",
        path: "/tools/display-sheet",
        permission: "tools.display_sheet.execute",
        description: "Manage display sheets",
        icon: FaDesktop,
    },
    {
        id: "missing-skus",
        name: "Missing SKUs",
        path: "/tools/missing-skus",
        permission: "tools.missing_skus.execute",
        description: "Find missing SKUs",
        icon: FaSearch,
    },
    {
        id: "variant-report",
        name: "Variant Report",
        path: "/tools/variant-report",
        permission: "tools.variant_report.execute",
        description: "Generate variant reports",
        icon: FaChartBar,
    },
    {
        id: "sales-floor-display",
        name: "Sales Floor Display",
        path: "/tools/sales-floor-display",
        permission: "tools.sales_floor_display.execute",
        description: "View sales floor layout",
        icon: FaDesktop,
    },
    {
        id: "sell-thru-report",
        name: "Sell-Thru Report",
        path: "/tools/sell-thru-report",
        permission: "tools.sell_thru_report.execute",
        description: "Analyze sell-through data",
        icon: FaChartBar,
    },
];
